import { graphql } from '@graphql/gql';

export const ACCEPT_TERMS = graphql(`
  mutation ACCEPT_TERMS($termsId: ID!, $locale: String) {
    updateAttendeeConsent(termsId: $termsId, locale: $locale) {
      id
      hasAccepted
    }
  }
`);
